import { render } from "./NewsContacts.vue?vue&type=template&id=9f5c13a6"
import script from "./NewsContacts.vue?vue&type=script&lang=js"
export * from "./NewsContacts.vue?vue&type=script&lang=js"

import "./NewsContacts.vue?vue&type=style&index=0&id=9f5c13a6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__